/* eslint-disable */
export default {
  // actions
  actions: {
    addDamage: 'Aggiungi',
    login: 'Accesso',
    select: 'Seleziona',
    clear: 'Pulire',
    continue: 'Continua',
    cancel: 'Cancella',
    import: 'Importazione',
    export: 'Esportazione',
    exportAll: 'Esportare tutti',
    selectFile: 'Selezionare il file',
    search: 'Cerca',
    save: 'Salva',
    delete: 'Cancellare'
  },
  downloadModal: {
    title: 'Scaricare il file',
    text:
      'Il file potrebbe richiedere diversi minuti per essere scaricato, per favore rimani sulla pagina.'
  },
  // component: furniture
  furniture: {
    title: 'Mobili',
    empty: {
      short: "Riferimento all'incidente mancante",
      long:
        "Per aggiungere i danni ai mobili, inserire il riferimento all'incidente e l'indirizzo."
    },
    kindOfProperty: 'Tipo di proprietà',
    kindOfPropertyOptions: {
      owner: 'Proprietario',
      renter: 'Inquilino'
    }
  },
  // component: warrantyLayout
  warrantyLayout: {
    registerSinister: 'Registrare la perdita',
    newSinister: 'Nuovo reclamo',
    registeredDamages:
      '0 x Danno Registrato | 1 x Danno Registrato | {count} x Danno Registrato',
    modals: {
      newSinister: {
        title: 'Nuovo reclamo. Sei sicuro?',
        body: 'Tutti i dati saranno ripristinati.'
      }
    }
  },
  damageTypeCpi: {
    calendarLabel: {
      literal: 'Data di acquisto'
    },
    priceDamage: {
      literal: "Prezzo d'acquisto"
    }
  },
  // component: warrantyRef
  warrantyRef: {
    sinisterRef: {
      literal: 'Riferimento della richiesta'
    },
    secondaryRef: {
      literal: 'Riferimento secondario (opzionale)'
    }
  },
  // component: warrantyProps
  warrantyProps: {
    aboutProperty: 'Informazioni aggiuntive',
    address: {
      literal: 'Indirizzo',
      placeholder: 'Inserisci una posizione'
    },
    zipCode: {
      literal: 'Codice postale'
    },
    propertyType: {
      literal: 'Tipo di proprietà',
      options: {
        appartment: 'Appartamento',
        maison: 'Casa',
        local_commercial: 'Locali commerciali'
      }
    },
    residentType: {
      literal: 'Tipo di residente',
      options: {
        propietarie: 'Proprietario',
        locataire: 'Inquilino',
        propietarie_non_occupant: 'Proprietario Non Occupante'
      }
    },
    moreThanTwoYears: {
      literal: "Età dell'edificio",
      options: {
        more: 'Più di 2 anni',
        less: 'Meno di 2 anni'
      }
    },
    map: {
      empty: {
        title: 'Nessun indirizzo',
        text: 'Inserisci un indirizzo valido'
      }
    },
    nameApplicant: {
      literal: `Nome dell'assicurato`,
      placeholder: 'Inserisci il nome'
    },
    formsList: 'Moduli',
    fnolIdsList: 'Contratto',
    userIdsList: 'Tipo di utente',
    buttonLink: {
      literal: `Visualizza il link utente`
    },
    modalLink: {
      buttonGenerateLink: 'Genera link',
      buttonCancel: 'Cancella',
      title: 'Collegamento utente',
      alertMessage: 'Le informazioni aggiuntive devono essere completate.',
      alertAction: 'Completa le informazioni aggiuntive'
    },
    moreInfoModal: {
      buttonGenerateLink: 'Informazioni aggiuntive',
      buttonCancel: 'Annullamento',
      title: 'Informazioni supplementari',
      send: 'Invia',
      personalInfo: {
        title: '1. Dati personali',
        name: 'Nome',
        surname: 'Cognome',
        phone: 'Telefono',
        city: 'Città'
      },
      contractInfo: {
        title: '2. Contratto',
        isValid: 'Il contratto è valido?',
        deductibles: 'Immobili deducibili (€)',
        allowance: 'Franchigia per abbellimento (€)',
        furnitureAllowance: 'Franchigia per mobili (€)',
        swimmingPool: 'Opzione(i) eliminata(e) - Piscina',
        externalFittings: 'Opzioni sottoscritte - Accessori esterni'
      },
      verifications: {
        title: '3. Assegni',
        beforeSinister:
          'Nessun sinistro in corso allo stesso indirizzo e con la stessa copertura, verificatosi nei 15 giorni precedenti o successivi al presente sinistro.',
        GaG: 'Nome di Gré à gré',
        ren: 'Nome di Ren',
        cause: 'Qual è stata la causa della perdita'
      },
      modalInformation: {
        title: 'Informazioni mancanti',
        literal: 'Per creare un collegamento, è necessario prima compilare le informazioni aggiuntive.',
        literal2: 'Si prega di completare questa sezione prima di procedere.',
        cancel: 'Annulla',
        completeInformation: 'Completa le informazioni',
      }
    },
    optionsUserType: {
      insured: 'Selfcare generico',
      professional: 'Selfcare BillMA Professionale',
      billma_insured: 'Selfcare Billma Assicurato',
      billma_agent: 'Selfcare Agente',
      billma_user: 'Selfcare BillMA',
      ren_professional: 'Selfcare Ren Professionale',
      ren_insured: 'Selfcare Ren Assicurato'
    },
    clientPhoneNumber: 'Numero di telefono',
    clientEmail: 'Email',
    clientValidationType: 'Tipo di convalida',
    countryCode: 'Prefisso',
    example: 'Esempio: ',
    requiredFields: {
      title: 'Campi obbligatori',
      text: 'Campi obbligatori non compilati'
    }
  },
  // component: warrantySticky
  warrantySticky: {
    analyze: 'Analizzare',
    generateReport: 'Generare un rapporto',
    generateReportFnol: 'Descrizione del danno',
    materialListBtn: 'Elenco dei materiali',
    smartReport: 'Rapporto di Smart',
    damageSummary: {
      title: 'Valutazione delle attività',
      tableHead: {
        damages: 'Danno',
        greAGre: 'Indennizo fai-da-te',
        reparationNetwork: 'Riparazione da parte di una rete approvata',
        reparationExcept: 'Riparazione al di fuori della rete'
      },
      tableSubHead: {
        embellishments: 'Abbellimento',
        immobilier: 'Beni immobili',
        mobilier: 'Mobili'
      },
      tableMain: {
        manpowerHours: 'MO (ore)',
        manpowerCost: 'MO (euro)',
        materialCost: 'Attrezzatura',
        totalCost: 'Totale',
        priceWithoutTaxes: 'IVA escl.',
        priceWithTaxes: 'IVA incl.'
      },
      description: {
        quantity: 'Quantità'
      }
    },
    damageCounters: {
      gag: 'Di comune accordo',
      materials: 'Materiali e forniture',
      estimatedTime: 'Tempo stimato',
      authorizedNetworkRepair: 'Rete di riparazione approvata',
      artessianRepair: 'Riparazione al di fuori della rete',
      immediate: 'Immediato',
      difference: 'Differito',
      ensembleImage: 'Foto generali',
      presImage: 'Foto ravvicinate',
      totalPrice: 'Prezzo totale'
    },
    manPower: {
      title: 'Variazione dei prezzi del lavoro',
      calculatePrice: 'Calcola il prezzo',
      cancel: 'Cancella',
      setPrice: 'Fissare i prezzi'
    },
    materialList: {
      title: 'Materiali e manodopera',
      manpowerTime: 'Lavoro (ore)',
      manpowerPrice: 'Lavoro (€)',
      manpowerTitle: 'Prezzo del lavoro',
      materials: 'Materiali',
      gag: 'Indennizzo per accordo',
      downloadPDF: 'Scaricare PDF',
      cancel: 'Cancella',
      send: 'Invia'
    }
  },
  // component: login
  login: {
    title: 'Mes dommages',
    titleMA: 'MAValue',
    text: 'Il tuo strumento di valutazione dei sinistri',
    authenticationError: 'Errore di autenticazione',
    authenticationBlock: 'Accesso bloccato, riprova dopo qualche minuto',
    authenticationOk: 'Accesso corretto',
    sso_processing: 'VVerificando identità...',
    sso_wait: 'Attendere un momento.',
    sso_error_title: 'Errore di autenticazione',
    sso_error_msg: 'Si è verificato un errore durante il login tramite SSO. Riprova o contatta l\'amministratore.',
    inputs: {
      username: 'Nome utente',
      password: 'Password'
    },
    login: 'Accesso'
  },
  // component: error
  error: {
    title: 'Mes Dommages',
    titleMA: 'MAValue',
    text: 'La pagina che stai cercando non esiste.',
    btn: 'Ritorno a'
  },
  // component: adminLayout
  adminLayout: {
    modals: {
      import: {
        title: 'Parametri di importazione',
        description:
          'Per aggiungere o modificare dei parametri, importate un file. Se il parametro non esiste, sarà creato o modificato.'
      },
      export: {
        title: 'Parametri di esportazione',
        description: 'Seleziona i campi da filtrare.'
      }
    },
    filters: {
      warranty: 'Gruppo di garanzia',
      subwarranty: 'Sottogruppo di garanzia'
    },
    notifications: {
      importedFile: {
        title: 'File importato',
        body: 'La tabella sarà caricata.'
      }
    }
  },
  // component: parameters (gagadmin)
  gagParameters: {
    title: 'Parametri',
    table: {
      paramName: 'Nome del parametro',
      paramValue: 'Valore del parametro',
      customizable: 'Modificabile'
    }
  },
  // component: repMat (gagadmin)
  gagRepMat: {
    title: 'Materiali di riparazione',
    table: {
      rep_type_code: 'Codice',
      rep_description: 'Descrizione',
      rep_mat: 'Materiale',
      mat_format_sale: 'Dimensione delle vendite',
      dam_measure_unit: 'Unità di misura',
      conv_unit_per_mat_measure: 'Unità di conversione per misura di materiale',
      mat_unit_price: 'Prezzo',
      is_hours: 'Solo ore',
      image: 'Immagine'
    }
  },
  // component: zipCode (gagadmin)
  gagZipCode: {
    title: 'Codice postale',
    table: {
      dept_code: 'Codice',
      zip_code_min: 'Codice postale minimo',
      zip_code_max: 'Codice postale massimo',
      country: 'Paese',
      clean_cost: 'Costo',
      displacement_hours: 'Ore di viaggio',
      coef: '*** coef',
      factmin: '*** factmin'
    }
  },
  // component: ajustage (gagadmin)
  gagAjustage: {
    title: "Regolare in base all'età del cliente",
    table: {
      interval_age_start: 'Età minima',
      interval_age_end: 'Età massima',
      age_coef: 'Coefficiente'
    }
  },
  // component: userLimits (gagadmin)
  gagUserLimits: {
    title: 'Limiti',
    table: {
      user: 'Utente',
      hour_price_max_limit: 'Prezzo massimo/ora.',
      hour_price_min_limit: 'Prezzo/ora min.'
    }
  },
  // component: salaries (gagadmin)
  gagSalaries: {
    title: 'Salari',
    table: {
      zip_code: 'Codice postale',
      csp: '*** csp',
      salary_hour: 'Prezzo/ora'
    }
  },
  // component: parameters (admin)
  parameters: {
    title: 'Parametri',
    table: {
      paramName: 'Nome del parametro',
      paramValue: 'Valore del parametro',
      customizable: 'Modificabile',
      type: 'Tipo'
    }
  },
  // component: reparations (admin)
  reparations: {
    title: 'Riparazione',
    warrantyid: 'Gruppo collaterale',
    subcategory: 'Sottocategoria',
    table: {
      repTypeCode: 'Codice di riparazione',
      description: 'Descrizione',
      type: 'Tipo di riparazione',
      surfaceUnit: 'Unità di misura',
      damagesType: 'Tipo di danno',
      priceCalcForm: 'Prezzo cálculo formulario'
    }
  },
  // component: coefficients (admin)
  coefficients: {
    title: 'Coeficienti',
    table: {
      repCodeType: 'Codice di riparazione',
      description: 'Descrizione',
      matSRen: 'Mat_REN',
      coefMat: 'Coef_mat',
      coefMo: 'Coef_mo',
      price: 'Prezzo'
    }
  },
  // component: depreciations (admin)
  depreciations: {
    title: 'Perdita di vita',
    table: {
      repTypeCode: 'Codice di riparazione',
      description: 'Descrizione',
      years: 'Años',
      depreciationPerc: 'Percentuale di riparazione'
    }
  },
  // component: transversalCosts
  transversalcosts: {
    title: 'Azioni aggiuntive',
    table: {
      damageType: 'Tipo di danno',
      componentName: 'Nome del componente',
      description: 'Descrizione',
      costFormat: 'Costo del formato',
      value: 'Valor'
    }
  },
  // component: users
  users: {
    title: 'Utenti',
    newUser: 'Nuovo utente',
    table: {
      username: 'Nome utente',
      firstName: 'Nome',
      lastName: 'Nome',
      email: 'E-mail',
      role: 'Ruolo',
      company: 'Azienda'
    },
    modals: {
      newUser: {
        title: 'Nuovo utente'
      },
      editUser: {
        title: 'Modifica utente'
      },
      deleteUser: {
        title: 'Eliminerai questo utente.',
        body: 'Questa azione è irreversibile. Vuoi continuare?'
      },
      user: {
        fields: {
          firstName: 'Nome',
          lastName: 'Nome e cognome',
          username: 'Nome utente',
          email: 'Email',
          company: "Nome dell'azienda",
          role: 'Ruolo utente',
          password: 'Password',
          repeatPassword: 'Ripetere la password'
        }
      }
    },
    filters: {
      company: 'Filtrare per azienda',
      role: 'Filtrare per ruolo'
    }
  },
  // component: forms
  adminForms: {
    filterLabel: 'Filtrare per forma',
    import: {
      title: 'Parametri di importazione',
      description:
        'Per aggiungere o modificare dei parametri, importate un file. Se il parametro non esiste, sarà creato o modificato.'
    },
    export: {
      title: 'Parametri di esportazione',
      description:
        'Per aggiungere o modificare i parametri, esporta un file e poi reimportalo.'
    },
    toast: {
      success: 'Il file è stato elaborato con successo',
      error: 'Il file non può essere elaborato.'
    },
    modal: {
      title: 'Elaborazione del documento',
      description:
        "Questo processo può richiedere alcuni minuti. Si prega di non chiudere l'applicazione."
    }
  },
  // component: small device modal
  smDevModal: {
    title: 'Risoluzione dello schermo non valida',
    text:
      'Il contenuto che desideri visualizzare non è disponibile per la tua risoluzione dello schermo. Si prega di riprovare da un dispositivo con una risoluzione superiore a 1024 pixel.'
  },
  // notification
  notifications: {
    error: {
      0: {
        title: 'Errore',
        body: "Errore durante l'azione"
      },
      400: {
        title: 'Campo obbligatorio non compilato',
        body: 'Si prega di rivedere i campi che non sono compilati'
      },
      500: {
        title: 'Errore',
        body: 'Errore generico'
      },
      409: {
        title: 'Errore di identificazione',
        body: 'Il reclamo esiste già'
      },
      title: 'Errore',
      body: "Errore durante l'azione"
    },
    addDamage: {
      title: 'Danno creato',
      body: 'Il danno è stato creato correttamente'
    },
    newSinister: {
      title: 'Nuovo reclamo',
      body: "L'ID della richiesta è stato cambiato"
    },
    deleteDamage: {
      title: 'Danno rimosso',
      body: 'Il danno è stato rimosso correttamente'
    },
    pdfDamages: {
      title: 'Rapporto creato',
      body: 'Rapporto creato correttamente'
    },
    pdfMaterial: {
      title: 'Rapporto creato',
      body: 'Rapporto creato correttamente'
    },
    mailPdfMaterial: {
      title: 'Email inviata',
      body: 'Email inviata correttamente',
      error: {
        title: 'Email non valida',
        body: "Per favore, inserisci un'email valida"
      }
    },
    moCalculation: {
      title: 'Prezzo aggiornato',
      body: 'Ricaricare il rapporto corrente'
    },
    changeLanguage: {
      title: 'Cambiare lingua',
      body: 'Referral'
    },
    loadSinisterOK: {
      title: 'Rivendicazione caricata',
      body: 'Aggiornare le informazioni'
    },
    loadSinisterKO: {
      title: 'Errore di perdita',
      body: 'Errore durante il caricamento della perdita'
    },
    paramChanged: {
      title: 'Parametro cambiato',
      body: 'La tabella verrà aggiornata automaticamente.'
    },

    user: {
      isRequired: {
        title: 'Campi mancanti',
        body: 'Completa tutti i campi correttamente'
      },
      isEmail: {
        title: 'Email non valida',
        body: `Per favore, inserisci un'email valida`
      },
      isSamePassword: {
        title: 'Ripetere la password',
        body: 'Le password non corrispondono'
      },
      createdUser: {
        title: 'Utente creato',
        body: 'Vista in fase di aggiornamento'
      },
      modifiedUser: {
        title: 'Utente cambiato',
        body: 'Vista in fase di aggiornamento'
      },
      deletedUser: {
        title: 'Utente cancellato',
        body: "Vista in fase di aggiornamento'"
      },
      error: {
        400: {
          title: 'Campi mancanti',
          body: 'Controlla il modulo prima di continuare'
        },
        500: {
          title: 'Errore',
          body: "Errore durante l'azione"
        },
        409: {
          title: `Errore di identificazione`,
          body: `Il reclamo esiste già`
        }
      }
    }
  },
  // charts view
  charts: {
    mapTitle: 'Reclami per località',
    sinisterEvolutionTitle: 'Stime e costi medi al mese',
    tableTitle: 'Tabella dei dati',
    noDataAvailable: 'Nessun dato disponibile',
    barChartDamageSubType: 'Costo medio per tipo di copertura',
    barChartDamageType: 'Costo medio per tipo di danno',
    barChartCompensationType: 'Costo per tipo di sinistro',
    pieChart: 'Ripartizione per sottotipo di danno',
    titleView: 'Dashboard',
    downloadData: 'Scaricare i dati',
    fromDate: 'Da',
    toDate: 'A',
    hintToDate: 'Si prega di selezionare la data "dalla data',
    hintFromDate: 'Si prega di selezionare la data "a data',
    tableHeadTitle: {
      company: 'Azienda',
      userName: 'Nome utente',
      l1: 'Livello 1',
      l2: 'Livello 2',
      l3: 'Livello 3',
      l4: 'Livello 4',
      q: 'q',
      averageCost: 'Costo medio',
      total: 'Totale'
    },
    bubbleChartLegend: {
      price: 'Quantità',
      damagesCount: 'Frequenza'
    }
  },

  // search view
  search: {
    secondaryRef: 'Riferimento secondario',
    status: 'Stato',
    gag: 'FDT',
    ren: 'RIK',
    asp: 'IND',
    createdDate: 'Data di creazione',
    updatedDate: 'Data di aggiornamento'
  },

  // tutorials view
  tutorials: {
    title: 'Tutorial',
    subtitle: 'Tutorial'
  },

  // Biens obiliers View
  biensMobiliers: {
    title: 'Beni mobili',
    searchEmpty: {
      search: 'La tua ricerca',
      notFound: 'non ha trovato alcun risultato'
    },
    text:
      "Usa il motore di ricerca o sfoglia il menu laterale per trovare l'articolo che stai cercando. Puoi anche scegliere tra le nostre categorie più popolari."
  },

  // dashboard view
  dashboard: {
    GAG: {
      title: 'Gag e televalutazioni',
      downloadData: 'Scarica i dati',
      filters: {
        date: 'Periodo',
        startDate: "Data d'inizio",
        endDate: 'Data di fine',
        orderBy: 'Ordina per',
        orderByOptions: {
          tmo: 'TMO',
          totalGAG: 'Total GAG',
          sinisterTotal: 'Totale téleval',
          conversion: 'Conversione'
        }
      },
      kpis: {
        gag: 'GAG realizzato',
        TE: 'Televa eseguita',
        gagWeek: 'Gestire con 1 GAG / settimana',
        gagSans: 'Gestire senza GAG'
      },
      table: {
        headers: {
          manager: 'Amministratore',
          conversion: 'Conversione',
          weeks: 'Settimane',
          evolution: 'Evoluzione',
          total: 'Totale',
          totalGAG: 'Totale GAG',
          totalTE: 'Totale téleval',
          TMO: 'TMO'
        }
      }
    }
  },

  // common
  common: {
    surface: 'Superficie',
    line: 'Linea',
    distance: 'Distanza',
    actualCalc: 'Calcolo in corso',
    selectOnTheMap: 'Selezionare sulla mappa per misurare',
    mapAction: 'Misurare la mappa',
    mapActionLine: 'Misurare la mappa',
    min: 'Minimo',
    max: 'Massimo',
    total: 'Totale',
    recommended: 'Consigliato',
    standard: 'Standard',
    noFile: 'Nessun file selezionato',
    email: 'Email',
    search: 'Cerca',
    results: 'Risultati',
    noresults: {
      short: 'Nessun risultato trovato',
      long: 'Non ci sono risultati per la tua ricerca'
    },
    true: 'Si',
    false: 'No',
    noOptions: 'Nessuna opzione',
    noSelected: 'Nessuna selezionata.',
    agentView: 'Vista agente',
    managerView: 'Vista manager',
    unit: '0 di unità | x {count} unità | x {count} di unità'
  },
  empties: {
    noResults: {
      title: 'Nessun risultato.',
      descr: 'Si prega di scegliere altri parametri di ricerca.'
    }
  },
  // Area component
  areaMeasurement: {
    damageArea: 'Area del danno',
    measurementTipe: 'In metri quadrati',
    heightMeasurement: 'Altezza',
    widhtMeasurement: 'Larghezza'
  }
}
